import { Component } from '@angular/core';

@Component({
  selector: 'app-legal-layout',

  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LegalLayoutComponent {}
